import {
  breakpointSizes,
  getBreakpointDown,
} from '@paywithextend/components'
import {
  base_colorAction,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;

  .payment-history-toolbar {
    display: flex;
    align-items: center;
    gap: ${spacing(10)};
    padding: ${spacing(4)} ${spacing(6)};
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  .payment-history-toolbar-search {
    display: flex;
    flex: 1;
    min-width: 0;
    height: ${spacing(10)};

    > .UtilityToolbarSearch.noHeader {
      flex: 1;
      min-width: 0;
      padding: 0;
    }

    .UtilityToolbarSearch.container {
      padding: 0 ${spacing(5)} 0 ${spacing(4)};
    }

    .UtilityToolbarSearch.input {
      min-width: 0;
    }

    .UtilityToolbarSearch.icon {
      margin-right: ${spacing(2)};
    }
  }

  .payment-history-toolbar-filters {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: ${spacing(3)};
  }

  .payment-history-grid {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .payment-history-invoice-error {
    padding: ${spacing(3)} ${spacing(6)};
    border-bottom: 1px solid ${base_colorContentBorder};
    color: ${text_colorTextPrimary};
    background: ${base_colorSurfaceSecondary};
    ${font_md};
  }

  .payment-invoice-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${spacing(7)};
    height: ${spacing(7)};
    padding: 0;
    border: 0;
    border-radius: ${spacing(1.5)};
    color: ${text_colorTextSecondary};
    background-color: transparent;
    cursor: pointer;

    &:hover {
      color: ${base_colorAction};
      background-color: ${base_colorSurfaceSecondary};
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
    }

    svg {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
  }

  .payment-history-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${spacing(5)};
    min-height: 56px;
    padding: 0 ${spacing(6)};
    border-top: 1px solid ${base_colorContentBorder};
    color: ${text_colorTextSecondary};
    ${font_md};

    button {
      border: 0;
      background: transparent;
      color: ${text_colorTextPrimary};
      font-size: 22px;
      cursor: pointer;
    }

    button:disabled {
      opacity: 0.35;
      cursor: default;
    }
  }

  .payment-history-message,
  .payment-history-empty {
    display: flex;
    flex: 1;
    min-height: 360px;
    align-items: center;
    justify-content: center;
    color: ${text_colorTextSecondary};
  }

  .payment-history-message {
    flex-direction: column;
    gap: ${spacing(4)};
  }

  .payment-history-empty {
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(12)} ${spacing(6)};
    text-align: center;

    h2 {
      margin: 0;
      font-size: 20px;
      line-height: 24px;
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
    }

    p {
      max-width: 470px;
      margin: 0;
      ${font_md};
      color: ${text_colorTextSecondary};
    }
  }

  .payment-history-empty-icon {
    display: flex;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${base_colorSurfaceSecondary};

    svg {
      width: 28px;
      height: 28px;
    }
  }

  .payment-history-empty-actions {
    display: flex;
    gap: ${spacing(4)};
    margin-top: ${spacing(2)};
  }

  ${getBreakpointDown(breakpointSizes.XSM)(css`
    .payment-history-toolbar {
      align-items: stretch;
      flex-direction: column;
      gap: ${spacing(3)};
    }

    .payment-history-toolbar-search,
    .payment-history-toolbar-filters,
    .payment-history-toolbar-filters > *,
    .payment-history-toolbar-filters .handleContainer,
    .payment-history-toolbar-filters button.toolbar {
      width: 100%;
    }

    .payment-history-toolbar-filters {
      flex-shrink: 1;
      flex-wrap: wrap;
    }

    .payment-history-toolbar-filters
      .UtilityToolbarDropdown.dropdownContainer {
      right: auto;
      left: 0;
      max-width: 100%;
      overflow-x: auto;
    }
  `)}
`
